<!-- 
	This is the Settings page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
    <div id="settings">
        <a-tabs class="tabs-sliding" default-active-key="1">
            <!-- Default Tab ( Messages ) -->
            <a-tab-pane key="1" tab="General">
                <a-row type="flex" :gutter="[24, 24]">
                    <a-col :span="24" :lg="6">
                        <!-- Page Anchors -->
                        <a-affix :offset-top="navbarFixed ? 100 : 10">
                            <a-card :bordered="false" class="header-solid mb-24">
                                <a-anchor :targetOffset="navbarFixed ? 100 : 10" :affix="false">
                                    <a-anchor-link href="#profile">
                                        <div slot="title" class="ant-list-item-meta">
                                            <a-icon
                                                type="appstore"
                                                theme="filled"
                                                class="text-gray-6 text-lg"
                                            />
                                            <h4 class="ant-list-item-meta-title">
                                                <span class="font-regular">Profile</span>
                                            </h4>
                                        </div>
                                    </a-anchor-link>
                                    <a-anchor-link href="#basic-info">
                                        <div slot="title" class="ant-list-item-meta">
                                            <a-icon
                                                type="snippets"
                                                theme="filled"
                                                class="text-gray-6 text-lg"
                                            />
                                            <h4 class="ant-list-item-meta-title">
                                                <span class="font-regular">Basic Info</span>
                                            </h4>
                                        </div>
                                    </a-anchor-link>
                                </a-anchor>
                            </a-card>
                        </a-affix>
                        <!-- / Page Anchors -->
                    </a-col>
                    <a-col :span="24" :lg="18">
                        <!-- User Profile card -->
                        <a-card
                            :bordered="false"
                            id="profile"
                            class="card-profile-head"
                            :bodyStyle="{ padding: 0 }"
                        >
                            <template #title>
                                <a-row type="flex" align="middle">
                                    <a-col :span="24" :md="24" class="col-info">
                    <span
                        class="ant-avatar ant-avatar-square ant-avatar-image"
                        style="
                        width: 74px;
                        height: 74px;
                        line-height: 74px;
                        font-size: 18px;
                      "
                    >
                      <img v-bind:src="rsprofile.logo"/>
                    </span>
                                        <div class="avatar-info">
                                            <h4 class="font-semibold m-0">{{ rsprofile.name }}</h4>
                                        </div>
                                    </a-col>
                                </a-row>
                            </template>
                        </a-card>
                        <!-- User Profile card -->

                        <!-- Basic Info card -->
                        <a-card
                            :bordered="false"
                            id="basic-info"
                            class="header-solid mb-24"
                        >
                            <template #title>
                                <h5 class="mb-0 font-semibold">Basic Info</h5>
                            </template>
                            <a-form @submit="handleSubmit">
                                <a-row :gutter="[24]">
                                    <a-col :span="24" :lg="24">
                                        <a-form-item class="mb-10" label="Nama RS" :colon="false">
                                            <a-input placeholder="Nama RS" v-model="rsprofile.name"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24" :lg="24">
                                        <a-form-item class="mb-10" label="Alamat" :colon="false">
                                            <a-textarea
                                                placeholder="Alamat"
                                                v-model="rsprofile.address"
                                                :rows="4"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24" :lg="24">
                                        <a-form-item class="mb-10" label="Kode Pos" :colon="false">
                                            <a-input
                                                placeholder="Kode Pos"
                                                v-model="rsprofile.post_code"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24" :lg="24">
                                        <a-form-item class="mb-10" label="No. Telp" :colon="false">
                                            <a-input
                                                type="tel"
                                                placeholder="No. Telp"
                                                v-model="rsprofile.phone"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24" :lg="24">
                                        <a-form-item class="mb-10" label="Tipe" :colon="false">
                                            <a-input
                                                type="tel"
                                                placeholder="Tipe"
                                                v-model="rsprofile.type"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24" :lg="24">
                                        <a-form-item class="mb-10" label="Website" :colon="false">
                                            <a-input
                                                type="url"
                                                placeholder="Website"
                                                v-model="rsprofile.web"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24" :lg="24">
                                        <a-form-item class="mb-10" label="Email" :colon="false">
                                            <a-input
                                                type="email"
                                                placeholder="Email"
                                                v-model="rsprofile.email"
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24" :lg="24">
                                        <a-form-item
                                            class="mb-10"
                                            label="Booking DU URL"
                                            :colon="false"
                                        >
                                            <a-input
                                                type="url"
                                                placeholder="Booking DU URL"
                                                v-model="rsprofile.bookingdu_base_url"
                                            />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row type="flex" align="middle">
                                    <a-col
                                        :span="24"
                                        :md="12"
                                        class="ml-auto"
                                        style="
                      display: flex;
                      align-items: center;
                      justify-content: flex-end;
                    "
                                    >
                                        <a-button
                                            type="primary"
                                            class="ml-10"
                                            @click="handleSubmit"
                                        >
                                            Simpan
                                        </a-button>
                                    </a-col>
                                </a-row>
                            </a-form>
                        </a-card>
                        <!-- / Basic Info card -->
                        <!-- / Delete Account card -->
                    </a-col>
                </a-row>
            </a-tab-pane>
            <!-- / Default Tab ( Messages ) -->

            <!-- Social Tab -->
            <a-tab-pane key="2" tab="Social">
                <a-card
                    class="header-solid"
                    :bodyStyle="{
            padding: '50px',
            height: '300px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }"
                >
                    <a href="#" class="text-center text-muted font-bold">
                        <h6 class="font-semibold text-muted">Empty Tab</h6>
                    </a>
                </a-card>
            </a-tab-pane>
            <!-- / Social Tab -->

            <!-- Notifications Tab -->
            <a-tab-pane key="3" tab="Notifications">
                <a-card
                    class="header-solid"
                    :bodyStyle="{
            padding: '50px',
            height: '300px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }"
                >
                    <a href="#" class="text-center text-muted font-bold">
                        <h6 class="font-semibold text-muted">Empty Tab</h6>
                    </a>
                </a-card>
            </a-tab-pane>
            <!-- / Notifications Tab -->

            <!-- Backup Tab -->
            <a-tab-pane key="4" tab="Backup">
                <a-card
                    class="header-solid"
                    :bodyStyle="{
            padding: '50px',
            height: '300px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }"
                >
                    <a href="#" class="text-center text-muted font-bold">
                        <h6 class="font-semibold text-muted">Empty Tab</h6>
                    </a>
                </a-card>
            </a-tab-pane>
            <!-- / Backup Tab -->
        </a-tabs>
    </div>
</template>

<script>
import ProfileRSApi from "../../repository/api/ProfileRSApi";

export default {
    props: ["navbarFixed"],
    data() {
        return {
            rsprofile: {
                id: "",
                name: "",
                web: "",
                director: "",
                lat: "",
                lng: "",
                type: "",
                bpjs_secret_key: "",
                bpjs_cons_id: "",
                bpjs_base_url: "",
                photo_path: "",
                address: "",
                phone: "",
                description: "",
                status: "",
                id_user: "",
                bpjs_faskes_code: "",
                warehouse_default_code: "",
                warehouse_default_search_code: "",
                doctor_schedule_status: "",
                rekmed_separator: "",
                rekmed_digit: "",
                aplicares_base_url: "",
                fleg: "",
                kemenkes_faskes_code: "",
                id_kelurahan: "",
                email: "",
                post_code: "",
                photo_region: "",
                key_inacbg: "",
                url_inacbg: "",
                id_provinsi: "",
                id_kabupaten: "",
                id_kabuapaten: "",
                bpjs_user_key: "",
                bookingdu_base_url: "",
                created_at: "",
                updated_at: "",
            },
            visibility: true,
            slack: true,
            spotify: true,
            atlassian: true,
            asana: false,
            tags: ["Vuejs", "Angular", "React"],
        };
    },
    computed: {
        days() {
            let days = [];

            for (let i = 1; i <= 31; i++) {
                days.push(i);
            }

            return days;
        },
        years() {
            let years = [];

            for (let i = 1930; i <= new Date().getFullYear(); i++) {
                years.push(i);
            }

            return years;
        },
    },
    mounted() {
        this.getProfileRS();
    },
    methods: {
        getProfileRS() {
            ProfileRSApi.get()
                .then((response) => {
                    this.rsprofile = response;
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },
        async handleSubmit(e) {
            e.preventDefault();
            await ProfileRSApi.post(this.rsprofile)
                .then(async (response) => {
                    await this.$swal({
                        type: "success",
                        title: "BERHASIL",
                        text: "Behasil disimpan",
                    });
                    await this.getProfileRS();
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },
        // Languages select field search method.
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },
    },
};
</script>

<style lang="scss" scoped>
#settings::v-deep {
    .ant-list {
        width: 100%;
    }

    .ant-list-item-meta-avatar {
        margin-right: 8px;
    }

    .ant-list-item-meta {
        align-items: center;
    }

    .ant-list-item-meta-title {
        margin: 0;
    }

    .ant-anchor-ink::before {
        display: none;
    }

    .ant-anchor-link {
        padding: 0;
        margin-top: 8px;
    }

    .ant-anchor-link a {
        width: 100%;
        border-radius: 8px;
        color: #67748e !important;
        padding: 10px 16px;
        background-color: transparent;
        transition: background-color 0.3s ease-in;
    }

    .ant-anchor-link a:hover {
        background-color: #eeeeee;
    }

    .ant-anchor-link a svg g {
        fill: #344767;
    }

    .ant-anchor-link a svg {
        margin-right: 8px;
    }

    .card-profile-head {
        margin: 0 0 24px;
    }

    .tags-field .ant-form-item-control {
        line-height: 33px;
    }

    .form-tag.ant-tag {
        border-radius: 20px;
        padding: 4px 10px;
        font-size: 12px;
        font-weight: 500;
        margin-right: 3.75px;
        margin-bottom: 3.75px;
        background-color: #3a416f;
        border: 1px solid #3a416f;
        color: #fff;
    }

    .form-tag.ant-tag .anticon-close {
        color: #fff;
        height: 16px;
        border-left: 1px solid hsla(0, 0%, 100%, 0.3);
        padding-left: 5px;
        padding-top: 2px;
        opacity: 0.75;
    }

    .form-tag.ant-tag .anticon-close:hover {
        color: #fff;
        opacity: 1;
    }

    .tags-field .ant-input {
        margin-bottom: 5px;
        margin-top: 4px;
    }

    .tags-field .ant-select {
        .ant-select-selection__choice__remove i {
            color: #fff;
            height: 16px;
            border-left: 1px solid hsla(0, 0%, 100%, 0.3);
            padding-left: 5px;
            padding-top: 2px;
            opacity: 0.75;

            &:hover {
                color: #fff;
                opacity: 1;
            }
        }

        .ant-select-selection__rendered > ul > li:not(.ant-select-search) {
            border-radius: 20px;
            padding: 2px 27px 2px 10px;
            font-size: 12px;
            font-weight: 500;
            margin-right: 3.75px;
            margin-bottom: 3.75px;
            background-color: #3a416f;
            border: 1px solid #3a416f;
            color: #fff;
            line-height: 2;
            height: 30px;
        }

        .ant-select-selection--multiple {
            padding: 8px 10px;
        }
    }
}
</style>